<div class ="flightbridge-right-rail__section-spacer"></div>

<div class="detail-page__rail-content">
  <div class="section__right-rail">
    <div class="section__header">
      <h2 class="section__header-text">AOPA Travel Discounts
        <div><img src="assets/images/PoweredbyFlightBridge.png" width="150" height="16" alt="Powered by FlightBridge"></div>
        <!-- <div class="airport-detail__flightbridge-subtext">Powered by <span class="airport-detail__flightbridge-subtext-name">FlightBridge</span></div> -->
      </h2>
    </div>
    <div class="section__body">
      <div class="section__content flightbridge-right-rail__content">
        <img src="assets/images/FBLogo2024Color.png" width="175" height="48" class="flightbridge-right-rail__logo" alt="FlightBridge">
        <div>FlightBridge is the ultimate all-in-one travel booking platform built for the general aviation community.
          AOPA Members receive free access to FlightBridge with AOPA discounted rates automatically applied.
          Members save an average of 30% on hotel bookings! Learn more about FlightBridge <a target="_blank" class="flightbridge-right-rail__link" href="https://www.aopa.org/travel/flightbridge">HERE</a>.</div>
        <div class="flightbridge-right-rail__button-bar-container">
          <div class="flightbridge-right-rail__button-inner-container">
            <div class="flightbridge-right-rail__button-header">
              <mat-icon fontSet="fa" fontIcon="fa-bed"></mat-icon> Hotels
            </div>
            <div class="flightbridge-right-rail__button">
              <a *ngIf="isMember" (click)="navigateToFlightBridge('hotel')" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Book Now
              </a>
              <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Join AOPA
              </a>
              <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Login/Create AOPA account
              </a>
            </div>
          </div>

          <div class="flightbridge-right-rail__button-inner-container">
            <div class="flightbridge-right-rail__button-header">
              <mat-icon fontSet="fa" fontIcon="fa-car"></mat-icon> Rental Cars
            </div>
            <div class="flightbridge-right-rail__button">
              <a *ngIf="isMember" (click)="navigateToFlightBridge('rentalcar')" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Book Now
              </a>
              <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Join AOPA
              </a>
              <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Login/Create AOPA account
              </a>
            </div>
          </div>

          <div class="flightbridge-right-rail__button-inner-container">
            <div class="flightbridge-right-rail__button-header">
              <mat-icon fontSet="fa" fontIcon="fa-plane"></mat-icon> Airlines
            </div>
            <div class="flightbridge-right-rail__button">
              <a *ngIf="isMember" (click)="navigateToFlightBridge('airline')" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Book Now
              </a>
              <a *ngIf="!isMember && isLoggedIn" (click)="navigateToJoinAOPA()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Join AOPA
              </a>
              <a *ngIf="!isLoggedIn" (click)="navigateToLogin()" mat-button
                 class="overview__action aopa-mat-btn aopa-mat-btn--filled">
                Login/Create AOPA account
              </a>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
